<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span class="dialog-title-with-name">
      <span>{{ data.titleKey | translate }}</span>
      <span class="dialog-title-name">{{ data.name }}</span>
    </span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="cancel()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<form (ngSubmit)="confirm()">
  <div class="container my-5">
    <p class="text-muted small mb-3">{{ data.textKey | translate }}</p>

    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>{{ 'modals.clinician-state-reason.reason-label' | translate }}</mat-label>
      <textarea matInput rows="3" maxlength="1000" name="reason" [(ngModel)]="reason"></textarea>
    </mat-form-field>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" (click)="cancel()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit">{{ 'modals.clinician-state-reason.confirm' | translate }}</button>
  </div>
</form>
